<template>
  <div class="relative w-full h-screen overflow-hidden">
    <div class="video-background">
      <div class="video-foreground">
        <iframe class="hero-video" allow="autoplay;" :src="iFrameSrc"></iframe>
      </div>
      <div class="video-overlay"></div>
    </div>

    <div class="relative max-w-screen-sm lg:max-w-screen-lg mx-auto text-white pt-48">
      <div class="font-body uppercase mb-8 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="1" viewBox="0 0 59 1">
          <line style="fill: none; stroke-linecap: round;" class="cls-1 stroke-current text-white" x2="58" transform="translate(0.5 0.5)"/>
        </svg>
        <div class="ml-2">Home</div>
      </div>
      <slot></slot>
    </div>

    <div class="scroll-indicator">
      <a @click="scroll" class="btn-scroll-anim"></a>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true
    }
  },
  methods: {
    scroll() {
      window.scrollBy(0, document.documentElement.clientHeight - document.getElementById("mainNavigation").clientHeight)
    }
  },
  computed: {
    iFrameSrc() {
      return "https://www.youtube.com/embed/" + this.videoId + "?controls=0&showinfo=0&loop=1&autoplay=1&modestbranding=1&rel=0&mute=1&playlist=" + this.videoId
    }
  }
}
</script>
<style lang="scss" scoped>
.video-background {
  background: #000;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;


  .video-foreground,
  .video-overlay,
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .video-overlay {
    background-image: url("/img/video-overlay-check.png");
  }

  @media (min-aspect-ratio: 16/9) {
    .video-foreground {
      height: 300%;
      top: -100%;
    }
  }

  @media (max-aspect-ratio: 16/9) {
    .video-foreground {
      width: 300%;
      left: -100%;
    }
  }
}

.scroll-indicator {
  position:absolute;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  width:50px;
  height:150px;
  z-index: 1;

  .btn-scroll-anim {
    opacity: 0.5;
    transition: opacity 0.5s ease;
    display: block;
    overflow: hidden;
    position: relative;
    width: 50px;
    height: inherit;
    text-indent: -9999px;
    cursor: pointer;

    &:before, &:after {
      content: '';
      position: absolute;
      background-image: url("/img/down-arrow-white.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 50px;
      width: 50px;
      height: 50px;
      left:50%;
      transform: translate(-50%,-50%);
      transition: all 0.5s ease;
    }

    &:before {
      top: 0;
      opacity: 0;
    }

    &:after {
      top: 50%;
      opacity: 1;
    }

    &:hover {
      opacity: 1;

      &:before {
        opacity: 1;
        top: 50%;
      }

      &:after {
        opacity: 0;
        top: 200%;
      }
    }

    &:focus {
      outline:none;
    }
  }
}
</style>